/**
 * Detect code generators.
 *
 * Generates snippets for the Perceptron `POST /v1/detect` API (the demo's Detect
 * mode) — a distinct REST endpoint from Compose's chat/completions, so it owns
 * its own config + generators. cURL ships today; the SDK-based Python snippet is
 * deferred until the `perceptron` SDK exposes a detect primitive (PRO-970).
 */

import { generateCurl } from "./curl";
import { DetectExportConfig, DetectExportLanguage } from "./types";

export * from "./types";
export { generateCurl } from "./curl";

/** Generate Detect code for the specified language. */
export function generateDetectCode(config: DetectExportConfig, language: DetectExportLanguage): string {
  switch (language) {
    case "curl":
      return generateCurl(config);
    default:
      throw new Error(`Unsupported language: ${language}`);
  }
}
